import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const LoadingSpinner: React.FC = () => (
  <Box
    data-testid="loading-spinner-container"
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    width="100vw"
    height="100vh"
    position="fixed"
    top={0}
    left={0}
    gap={2}
    bgcolor="background.default"
    zIndex={1300}
  >
    <CircularProgress color="primary" />
    <Typography variant="h6">Loading...</Typography>
  </Box>
);

export default LoadingSpinner;
